// Helper functions for program categories

export function flattenCategories(categories) {
  let result = [];
  for (const cat of categories) {
    result.push({ id: cat.id, name: cat.name });
    if (cat.children && cat.children.length > 0) {
      result = result.concat(flattenCategories(cat.children));
    }
  }
  return result;
}

export function getCategoryActions(category) {
  const actions =
    category.categoryCode === "ROOT"
      ? ["Associate Template", "Add Sub-Category", "Edit Template"]
      : [
          "Associate Template",
          "Edit Template",
          "Add Category",
          "Edit Category",
          "Add Sub-Category",
          "Delete Category",
          "Mark As Hidden",
          "Mark As Unhidden",
        ];
  return actions;
}

export function findAndUpdateCategory(categories, id, updater) {
  return categories.map((cat) => {
    if (cat.id === id) {
      return updater(cat);
    } else if (cat.children && cat.children.length > 0) {
      return {
        ...cat,
        children: findAndUpdateCategory(cat.children, id, updater),
      };
    } else {
      return cat;
    }
  });
}

export function findAndRemoveCategory(categories, id) {
  let removed = null;
  const filtered = categories
    .filter((cat) => {
      if (cat.id === id) {
        removed = cat;
        return false;
      }
      return true;
    })
    .map((cat) => ({
      ...cat,
      children: cat.children
        ? findAndRemoveCategory(cat.children, id).categories
        : [],
    }));
  if (!removed) {
    for (const cat of categories) {
      if (cat.children && cat.children.length > 0) {
        const result = findAndRemoveCategory(cat.children, id);
        if (result.removed) {
          removed = result.removed;
          cat.children = result.categories;
        }
      }
    }
  }
  return { categories: filtered, removed };
}

export function insertCategory(categories, parentId, newCat) {
  if (!parentId) {
    return [...categories, newCat];
  }
  return categories.map((cat) => {
    if (cat.id === parentId) {
      return { ...cat, children: [...cat.children, newCat] };
    } else if (cat.children && cat.children.length > 0) {
      return {
        ...cat,
        children: insertCategory(cat.children, parentId, newCat),
      };
    } else {
      return cat;
    }
  });
}

export function isDescendant(categories, id, targetId) {
  if (id === targetId) return true;
  for (const cat of categories) {
    if (cat.id === targetId) {
      if (cat.children && cat.children.length > 0) {
        if (cat.children.some((child) => isDescendant([child], id, child.id)))
          return true;
      }
    } else if (cat.children && cat.children.length > 0) {
      if (isDescendant(cat.children, id, targetId)) return true;
    }
  }
  return false;
}

export function findParentId(categories, id, parentId = "") {
  for (const cat of categories) {
    if (cat.id === id) return parentId;
    if (cat.children && cat.children.length > 0) {
      const found = findParentId(cat.children, id, cat.id);
      if (found) return found;
    }
  }
  return "";
}

export function mapApiCategoryToLocal(cat) {
  return {
    id: cat.id,
    name: cat.categoryName,
    categoryCode: cat.categoryCode,
    categoryDescription: cat.categoryDescription || "",
    categoryLogoUri: cat.categoryLogoUri || null,
    isHidden: cat.isHidden || false, // Use the isHidden property from API response
    hidden: cat.isHidden || false, // Also map to hidden for backward compatibility
    children: (cat.subCategoryVOs || []).map(mapApiCategoryToLocal),
  };
} 